import styled from 'styled-components';
import { devices, fontFamily, fontSize } from '../../../Styles';

export const InputContentContainer = styled.div<{ error?: string }>`
  box-sizing: border-box;
  display: flex;
  border: ${({ error, theme }) =>
    error ? `1px solid ${theme.palette.alert100}` : `1px solid ${theme.brandTheme.brand100}`};
  align-items: center;
  justify-content: center;
  border-radius: 2px;
  padding: 5px 5px;
  margin-top: 10px;
  width: 100%;
  i {
    margin-right: 8px;
  }
  @media ${devices['no-mobile']} {
    justify-content: flex-start;
    i {
      margin-right: 4px;
    }
  }
`;
export const CustomInput = styled.textarea`
  width: 100%;
  border: 0;
  padding: 0;
  resize: none;
  height: 80px;
  font-family: ${fontFamily};
  font-size: ${fontSize['inputs-text-mobile']};
  ::placeholder {
    color: ${({ theme }) => theme.palette.graysPlaceholder}!important;
  }
  &:focus {
    outline: none;
  }
  @media ${devices['no-mobile']} {
    font-size: ${fontSize['inputs-text-desktop']};
  }
`;
